import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-empty-layout',
  templateUrl: './empty-layout.component.html',
  styleUrls: ['./empty-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule],
})
export class EmptyLayoutComponent {}
